import { createFileRoute } from "@tanstack/react-router";
import { serviceSchemaScripts } from "@/lib/service-schema";
import CreacionEcommerceShopify from "@/pages/servicios/CreacionEcommerceShopify";


export const Route = createFileRoute("/servicios/creacion-ecommerce-shopify")({
  head: () => ({
    meta: [
      { title: "Tiendas Online Shopify Profesionales | SEOEVOLUTION" },
      { name: "description", content: "Tu tienda online debería vender sola. Creamos tu Shopify con diseño personalizado, SEO perfecto y UX que convierte. Sin plantillas. Diagnóstico personalizado." },
      { name: "keywords", content: "Shopify, crear tienda online, ecommerce, desarrollo web, tienda virtual, comercio electrónico" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://agenciaseoevolution.com/servicios/creacion-ecommerce-shopify" },
      { property: "og:title", content: "Tiendas Online Shopify Profesionales | SEOEVOLUTION" },
      { property: "og:description", content: "Tu tienda online debería vender sola. Creamos tu Shopify con diseño personalizado, SEO perfecto y UX que convierte." },
      { name: "twitter:title", content: "Tiendas Online Shopify Profesionales | SEOEVOLUTION" },
      { name: "twitter:description", content: "Tu tienda online debería vender sola. Creamos tu Shopify con diseño personalizado, SEO perfecto y UX que convierte." },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/servicios/creacion-ecommerce-shopify" }],
    scripts: serviceSchemaScripts("creacion-ecommerce-shopify"),
  }),
  component: CreacionEcommerceShopify,
});
